import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
}

export const ConsumerStickyPanel: React.FunctionComponent<Props> = ({ children, className }) => {
  const theClassName = clsx('ConsumerStickyPanel', className);

  return <div className={theClassName}>{children}</div>;
};
